export const publications = [
  {
    authors: "Wong, R., et al.",
    title:
      "Critical statistical assessment of data in metal additive manufacturing",
    journal: "Materials & Design",
    year: "2025",
    doi: "https://doi.org/10.1016/j.matdes.2025.114301",
    status: "published",
  },
  {
    authors: "Wong, R., et al.",
    title: "Interpretable machine learning for process-property of steels",
    journal: "Journal of Applied Physics",
    year: "Forthcoming",
    doi: null,
    status: "invited",
  },
];
